<template>
  <HeadlineComponent>Gast "{{ name }}" bearbeiten</HeadlineComponent>
  <h2 v-if="ticketing_enabled">Ticket</h2>
  <template v-if="guest.ticket && ticketing_enabled">
    <div v-if="guest.ticket.user_id">
      Zugeordnetes Crewmitglied: <RouterLink :to="`/user/${guest.ticket.user.id}`"> {{ guest.ticket.user.full_name }}
      </RouterLink><br />
      <LoadingButton class="btn-danger" :loading="guest.ticket.loading" @click.prevent="disconnectTicket()">Verbindung
        aufheben</LoadingButton>
    </div>
    <div v-if="!guest.ticket.user_id" class="input-group">
      <select v-model="new_user" id="type" class="form-control">
        <option :value="{}">-- Auswählen --</option>
        <option v-for="user of users" :key="user.id" :value="user">{{ user.full_name }}</option>
      </select>
      <LoadingButton :loading="guest.ticket.loading" class="btn-primary" @click.prevent="connectTicket()">Zuordnen
      </LoadingButton>
    </div>
    Wird versendet an {{ guest.ticket.email }}
    <div class="form-group mt-2">
      <span v-if="guest.ticket.ticket_sent" class="fa fa-check"></span>
      <span v-if="!guest.ticket.ticket_sent" class="fa fa-close"></span>
      Ticket verschickt
    </div>
    <div class="form-group mt-2" v-if="guest.ticket.ticket_sent">
      <LoadingButton :loading="guest.ticket.loading" @click.prevent="resendTicket(guest.ticket)" class="btn-primary">
        Ticket neu senden</LoadingButton>
    </div>
  </template>
  <Form class="form-horizontal" @submit="update" :initialValues="guest" v-if="guest.id">
    <h2>Persönliche Daten</h2>
    <GuestForm :eventId="$route.params.event"></GuestForm>
    <div class="form-group">
      <LoadingButton :loading="loading" class="btn-primary">Speichern</LoadingButton>
    </div>
  </Form>
</template>

<script>
import ticketService from "@/services/ticket.service.js";
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import guestService from "@/services/guest.service.js";
import eventService from "@/services/event.service";
import router from "@/router/index.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { useConfigStore } from "@/stores/config";
import userService from "@/services/user.service";
import { Form } from 'vee-validate';
import { setErrors } from '@/helper/ErrorToActions.js';
import GuestForm from "@/components/GuestForm.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateGuestView",
  components: { LoadingButton, HeadlineComponent, Form, GuestForm },
  data() {
    return {
      name: '',
      guest: {},
      possibleUsers: [],
      users: [],
      new_user: {},
      loading: false
    }
  },
  async beforeRouteEnter(to, from, next) {
    let users = []
    let guest = {}
    try {
      let response = await guestService.get(to.params.event, to.params.id)
      guest = response.data;
      guest.type_id = guest.type_id || "";
    } catch (e) {
      console.log(e);
      Sentry.captureException(e);
      useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
      window.scrollTo(0, 0);
    }
    try {
      let response = await userService.usersWithoutTicket(to.params.event)
      users = response.data;
    } catch (e) {
      console.log(e);
      Sentry.captureException(e);
      useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
      window.scrollTo(0, 0);
    }
    next(vm => {
      vm.guest = guest;
      vm.users = users;
      vm.name = guest.full_name;
    })
  },
  computed: {
    ...mapState(useConfigStore, ['ticketing_enabled'])
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async update(data, actions) {
      this.loading = true;
      try {
        await guestService.update(this.guest.event_id, this.guest.id, data);
        this.addAlert('success', 'Der Gast wurde erfolgreich gespeichert');
        router.push(`/events/${this.guest.event_id}/guest`);
      } catch (e) {
        if (e.response && e.response.status === 420) {
          this.possibleUsers = e.response.data;
        } else if (e && e.response && e.response.data && e.response.data.errors) {
          setErrors(e.response.data.errors, actions)
        } else if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    },
    async connectTicket() {
      this.guest.ticket.loading = true
      try {
        await eventService.connect(this.guest.ticket.event_id, this.new_user.id, this.guest.ticket.id);
        this.addAlert('success', 'Das Ticket wurde verbunden');
        window.scrollTo(0, 0);
        this.guest.ticket.user_id = this.new_user.id;
        this.guest.ticket.user = this.new_user;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          console.log(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.guest.ticket.loading = false
    },
    async disconnectTicket() {
      this.guest.ticket.loading = true
      try {
        await eventService.disconnect(this.guest.ticket.event_id, this.guest.ticket.id);
        this.addAlert('success', 'Die Ticketverbindung wurde aufgehoben');
        window.scrollTo(0, 0);
        this.guest.ticket.user_id = null
        this.guest.ticket.user = null
        var response = await userService.usersWithoutTicket(this.guest.ticket.event_id)
        this.users = response.data;
      } catch (e) {
        if (e) {
          console.log(e);
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.guest.ticket.loading = false
    },
    async resendTicket(ticket) {
      ticket.loading = true
      try {
        await ticketService.resendTicket(ticket.event_id, ticket.id);
        this.guest.ticket.ticket_sent = false;
        this.addAlert('success', 'Das Ticket wird neu versandt');
        window.scrollTo(0, 0);
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      ticket.loading = false
    }
  }
}
</script>

<style scoped></style>